import type { StateService } from '@uirouter/angularjs';
import { upgradeExternalNg1Dependency } from '../common/ng1-upgrade-factory';

export const $stateToken = upgradeExternalNg1Dependency<StateService>('$state');
